<div id="container-portalComponent">
  <div class="alert alert-warning" *ngIf="proquestAccountDisabled && !loading" role="alert">
    {{productDisabledMessage}}
  </div>

  <div class="container-loading" *ngIf="loading || error">
    <pq-loading [loading]="loading" [error]="error" [msg]="msg"></pq-loading>
  </div>

  <div class="container-productLinks" *ngIf="!loading && !error">
    <p>Homework Central &reg; | Providing authoritative information on a variety of topics to assist student research
    </p>
    <h2>Select a resource</h2>
    <ul>
      <ng-container *ngFor="let product of getProducts(); let i = index">
        <li
          *ngIf="product.profile != 'proquest' && product.profile !== 'alexanderstreet' &&(!product['profile']?.includes('radr')  && product.profile!='glmu2' && product.profile!='avc')">
          <article>
            <a href="# {{product.profile}}" (click)="handleProductLink(product.profile, $event)"
              [ngStyle]="{ 'background-image': 'url(' + product.imgUrl + ')' }">
              <section>
                <h3 [innerHTML]="product.name"></h3>
                <div>
                  <p [innerHTML]="product.description"></p>
                </div>
              </section>
            </a>
          </article>
        </li>
      </ng-container>
    </ul>
  </div>

  <div class="container-productLinks" *ngIf="!loading && !error && filteredProducts().length > 0">
    <h2> Select from multimedia collections</h2>
    <ul>
      <ng-container *ngFor="let product of getProducts(); let i = index">
        <li
        *ngIf="product.profile !== 'proquest' && product.profile !== 'alexanderstreet' && ((product.profile === 'radr' || product.profile === 'glmu2' || product.profile === 'avc') || (product.profile === 'radr2' && !hasBothRadrAndRadr2))">
          <article>
            <a href="# {{product.profile}}" (click)="handleProductLink(product.profile, $event)"
              [ngStyle]="{ 'background-image': 'url(' + product.imgUrl + ')' }">
              <section>
                <h3 [innerHTML]="product.name" [ngClass]="{'alexander-avc':product.profile==='avc'}"></h3>
                <div [ngClass]="{'alexander-street':product.profile==='avc'}">
                  <p [innerHTML]="product.profile=='avc'?alexanderStreet:product.description"
                    [ngClass]="{'alexander-content':product.profile==='avc'}"></p>
                </div>
              </section>
            </a>
          </article>
        </li>
      </ng-container>
    </ul>
  </div>

  <div class="container-platformLinks" *ngIf="!loading && !error">
    <ng-container *ngIf="hasProquest() || hasAlexanderStreet()">
      <h2>Search multiple databases</h2>
      <div class="container-platformLinksContent">
        <div class="platformTile" *ngIf="hasProquest()" id="pqPlatform">
          <div class="platformTileText">
            <div class="pqtitle">
              <a href="#proquest" (click)="handleProductLink('proquest', $event)">ProQuest Platform</a>
            </div>
            <p class="pqdesc">Search databases on the ProQuest Platform</p>
          </div>
        </div>
        <div class="platformTile" *ngIf="hasAlexanderStreet()" id="alexanderStreetPlatform">
          <div class="platformTileText">
            <div class="pqtitle">
              <a href="#proquest" (click)="handleAlexanderStreetLink($event)">Alexander Street Platform</a>
            </div>
            <p class="pqdesc">Search databases on the Alexander Street Platform</p>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <div class="container-helpMessage well well-lg" *ngIf="!loading">
    <p>Need Help using your ProQuest products? Visit the <a href="http://support.proquest.com/#submitcase"
        target="_proquest">ProQuest Support Center</a>.</p>
  </div>
</div>